import { useFeatureFlagPayload as useFFPayload } from 'posthog-js/react'

import { LogoKey } from '@/lib/ui/logo-key-to-logo'

type RemoteConfigTypeMap = {
  'org-id-to-logo-key': Record<string, LogoKey>
  'maintenance-banner': string
  'org-id-to-portal-artifact-display-names': Record<
    string,
    Record<string, { label: string; satisfiedBy: string[] }[]>
  >
}

type RemoteConfigKey = keyof RemoteConfigTypeMap

export const useRemoteConfigPayload = <T extends RemoteConfigKey>(
  featureFlag: T,
):
  | { isLoading: true; payload: undefined }
  | { isLoading: false; payload: RemoteConfigTypeMap[T] } => {
  const payload = useFFPayload(featureFlag)
  if (payload === undefined) {
    return { isLoading: true, payload: undefined }
  } else {
    return { isLoading: false, payload: payload as RemoteConfigTypeMap[T] }
  }
}
